module.exports = __webpack_public_path__ + "index/img/zhangjia.57603a6d.png";